import { SubmissionStatus } from 'components/molecules/SubmissionStatus'
import { FC, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { useGET_studentAssignmentsQuery } from 'redux/api/assignmentsApi'
import { useGET_groupCoursesQuery } from 'redux/api/groupCoursesApi'
import { MAX_PER_PAGE } from 'utils/constants'
import { formatDate } from 'utils/helpers'


const SectionSubjectAssignments: FC = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  
  const [groupCourse, setGroupCourse] = useState(null)

  const { data } = useGET_groupCoursesQuery({page: 1, page_size: MAX_PER_PAGE})
  const { data: assignments } = useGET_studentAssignmentsQuery({page: 1, page_size: 12, group_course: groupCourse}, {skip: !groupCourse})

  useEffect(() => {
    if (data?.results.length > 0) {
      setGroupCourse(data?.results[0].id ?? null)
    }
  }, [data])


  return (
     <div>
        <div style={{marginBottom: '10px'}}>{t('common.assignments')}</div>
        <div className="workspace-tabs">
            {data?.results?.map((s) => <div key={s.id} className={`workspace-tab orange ${groupCourse==s.id && 'selected'}`}
                onClick={() => {setGroupCourse(s.id)}}
            >
                {s.subject?.title}
            </div>)}    
        </div>
        <div className="workspace-tabs-box" style={{ background: '#FEFAE4', padding: '10px' }}>
            <div className='timeline'>
              {assignments && assignments.results
                .slice(0,3)
                .map(a => <div key={a.id} className='time-box'
                  onClick={() => navigate(`/student-assignments/view/${a.id}`)}
                >

                  <div className="time-box-title">{a.title}</div>
                  <div>{t('common.due-date')}: {formatDate(a.due_datetime)}</div>
                  <div className='time-box-status'>
                    
                      <SubmissionStatus status={a.submission_status} grade={parseFloat(a.grade)} />
                 
                  </div>
              </div>)}
            </div>
        </div>
     </div>
  )
}

export default SectionSubjectAssignments
